<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("incidenciaOperario")}}</li>
                    </ol>
                </nav>
            </div>
            <CabeceraInformes
                :idBusiness="idBusiness"
                :listBusinesses="listBusinesses"
                :idTpv="this.idTpv"
                :listTpv="listTpv"
                :dateto="dateto"
                :datefrom="datefrom"
                id="cabecera"
                :conTodos="true"
            />
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <template v-else-if="respuesta">
                <div class="col-md-5">
                    <template v-if="list.length>0">
                        <!--<div class="row justify-content-between div-export">

                           <div class="col-md-2 col-xs-12 text-right">
                                <el-dropdown>
                                    <el-button type="primary" size="small">
                                        <i class="fa fa-file"></i>
                                        {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDF">
                                            <el-dropdown-item class="text-danger">
                                                <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcel">
                                            <el-dropdown-item class="text-success">
                                                <strong>
                                                    <i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}
                                                </strong>
                                            </el-dropdown-item>
                                        </a>
                                    </el-dropdown-menu>
                                </el-dropdown>

                            </div>
                        </div>-->
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped text-nowrap">
                                <thead class="thead-dark">
                                <tr style="cursor: pointer;">
                                    <th v-if="ordenacionOperario===0" @click="sortedArrayNameASC('Nombre')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("nombre")}}
                                    </th>
                                    <th v-else @click="sortedArrayNameDESC('Nombre')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("nombre")}}
                                    </th>
                                    <th v-if="ordenarIssues===0" @click="sortedArrayIssuesASC('numIssues')"><i
                                            style="color: white" class="fa fa-angle-up"></i> Incidencias
                                    </th>
                                    <th v-else @click="sortedArrayIssuesDESC('numIssues')"><i
                                            style="color: white" class="fa fa-angle-down"></i> Incidencias
                                    </th>

                                    <th v-if="ordenarDinero===0" @click="sortedArrayDineroASC('Dinero')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("importe")}}
                                    </th>
                                    <th v-else @click="sortedArrayDineroDESC('Dinero')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}}
                                    </th> 
                                    
                                    <th>{{$t("acciones")}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="obj in list">
                                    <td>{{obj.Nombre}}</td>
                                    <td class="text-right">{{obj.numIssues}}</td>
                                    <td v-if="obj.Dinero > 0" class="text-left table-success">
                                        {{obj.Dinero | currency}}
                                    </td>
                                    <td v-else class="text-left table-danger">
                                        {{obj.Dinero | currency}}
                                    </td>
                                    <td align="center">

                                      <router-link v-tooltip.top-center="$i18n.t('verIncidenciaOperario')"
                                                     :to="{name: 'incidencias-operario', params:{workerName:obj.Nombre, idBusiness:idBusiness, idTpv: idTpvAMandar}}"
                                                     class="btn btn-primary btn-link">
                                            <i class="fa fa-eye"></i>
                                        </router-link>

                                    </td>
                                    

                                </tr>
                                </tbody>
                                <tfoot>
                                <tr class="table-success">
                                    <td><strong>{{$t("total")}}</strong></td>
                                    <td class="text-right"><strong>{{getTotalIncidencias}}</strong></td>
                                    <td class="text-right"><strong>{{getTotalDinero | currency}} </strong></td>

                                    <td></td>

                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </template>
                    <template v-else>
                        <div class="alert alert-danger" role="alert">
                            {{$t("noHay")}} <strong>{{$t('incidenciaOperario')}}</strong> {{$t("rangoDeFechas")}}
                        </div>
                    </template>
                </div>

                <div class="col-md-7 ">
                    <div class="card">
                        <div class="chart-container col-md-12 ">
                            <canvas id="chart"></canvas>
                        </div>

                    </div>
                </div>
            </template>
        </div>
    </div>

</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Loading} from 'element-ui'
    import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
    import swal from 'sweetalert2'
    import moment from 'moment'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.loading = Loading.service({ text: "Cargando..." });
            this.$store.dispatch("setNameRoute", this.$i18n.t('incidenciaOperario'));
            this.getBusiness();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {

                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;

            }

        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            CabeceraInformes
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                idBusiness: 0,
                list: [],
                mode: 0,
                objectChart: null,
                contador: 0,
                listTpv: [],
                idTpv: -1,
                dateRangeOptions1: {
                    firstDayOfWeek: 1
                },

                ordenacionOperario: 0,
                ordenarImporte: 0,
                ordenarInvitations: 0,
                ordenarDifHora: 0,
                ordenarSueldo: 0,
                ordenarEfectivo:0,
                ordenarTarjeta:0,
                ordenarCheque:0,
                ordenarIssues:0,
                ordenarDinero:1,
                idTpvAMandar:" ",

                respuesta: true,

            }
        },
        computed: {
            ...mapState(["permiso"]),
           /* urlExportPDF() {
                // return "../api/public/index.php/workers/exportVentasWorkers/PDF?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
                
                let idTpvAMandar = "";

                if (this.idTpv == -1) {
                    idTpvAMandar = 0;
                } else {
                    idTpvAMandar = this.idTpv;
                }

                return this.$store.getters.apiUrl + "/workers/exportAperturasWorkers/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + idTpvAMandar + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt


            },
            urlExportExcel() {
                let idTpvAMandar = "";

                if (this.idTpv == -1) {
                    idTpvAMandar = 0;
                } else {
                    idTpvAMandar = this.idTpv;
                }

                return this.$store.getters.apiUrl + "/workers/exportAperturasWorkers/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + idTpvAMandar + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt


            },*/

            getTotalIncidencias() {
                let total = 0;
                this.list.forEach(function (d) {
                  
                    total += d.numIssues;
 
                });
                return total;
            },
            getTotalDinero() {
                let total = 0;
                this.list.forEach(function (d) {
                    total += d.Dinero;
                });
                return total;
            },
        },
        methods: {

            cambioBusiness(idBusinessData, listTpv) {
                if (listTpv) {
                    this.listTpv = listTpv;
                }
                
                
                this.loading = Loading.service({ text: "Cargando..." });
                this.idBusiness = idBusinessData;
                this.idTpv = -1;
                this.list = [];
                this.cambioTpv(this.idTpv);
            },

            emitirConsulta() {
                this.loading = Loading.service({ text: "Cargando..." });
                //this.getSalesOperarios();
                this.getIncidenciasOperarios();
            },

            cambioTpv(idTpvData, filtrar) {

                if (idTpvData != undefined) {
                    this.idTpv = idTpvData;
                }
                
                this.idTpv=idTpvData;
                this.emitirConsulta();
            },

            cambioHora(dates) {
                this.datefrom = dates[0]
                this.dateto = dates[1]
            },
            
            sortedArrayNameASC: function () {
                this.ordenacionOperario = 1;

                function compare(a, b) {
                    if (a.Nombre.toUpperCase() < b.Nombre.toUpperCase())
                        return -1;
                    if (a.Nombre.toUpperCase() > b.Nombre.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
           

            sortedArrayNameDESC: function () {
                this.ordenacionOperario = 0;

                function compare(a, b) {

                    if (a.Nombre.toUpperCase() > b.Nombre.toUpperCase())
                        return -1;
                    if (a.Nombre.toUpperCase() < b.Nombre.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayIssuesASC: function () {
                this.ordenarIssues = 1;

                function compare(a, b) {
                    if (a.numIssues < b.numIssues)
                        return -1;
                    if (a.numIssues > b.numIssues)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayIssuesDESC: function () {
                this.ordenarIssues = 0;

                function compare(a, b) {

                    if (a.numIssues > b.numIssues)
                        return -1;
                    if (a.numIssues < b.numIssues)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayDineroASC: function () {
                this.ordenarDinero = 1;

                function compare(a, b) {
                    if (a.Dinero < b.Dinero)
                        return -1;
                    if (a.Dinero > b.Dinero)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayDineroDESC: function () {
                this.ordenarDinero = 0;

                function compare(a, b) {

                    if (a.Dinero > b.Dinero)
                        return -1;
                    if (a.Dinero < b.Dinero)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        vm.listBusinesses = response.data.result;

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        } else {

                            vm.idBusiness = response.data.result[0].id;
                        }

                        //vm.getSalesOperarios();
                        vm.getTpv();

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getTpv() {

                this.listTpv = [];

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                    .then(function (response) {
                        if (response.data.response) {


                            for (let i = 0; i < response.data.result.length; i++) {
                                vm.idsTPV.push(response.data.result[i].id)
                            }

                            vm.listCheckBoxTpv = response.data.result;


                            for (let i = 0; i < response.data.result.length; i++) {

                                let printername = {
                                    nameShow: response.data.result[i].nameShow,
                                    id: response.data.result[i].id
                                };

                                vm.listTpv.push(printername)
                            }

                            vm.getIncidenciasOperarios();


                        }


                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getIncidenciasOperarios() {

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                    this.loading.close();
                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        this.loading.close();
                    } else {

                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

    

                        if (this.idTpv == -1) {
                            this.idTpvAMandar = 0;
                        } else {
                            this.idTpvAMandar = this.idTpv;
                        }

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                idTpv: this.idTpvAMandar,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt,
                                desde: 1,
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        this.loading.close();

                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "workers/getIncidenciasOperarios", config)
                            .then(function (response) {
                                if (response.data.response) {
                                    vm.list = response.data.result;
                                    vm.respuesta = true;
                                    vm.initChart();
                                    
                                    
                                } else if (response.data.response == false) {
                                    swal({
                                    title: "Lo sentimos",
                                    text: response.data.result,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "info",
                                    });
                                    vm.respuesta = false;
                                } else {
                                    swal({
                                        title: $t('accesoDenegado'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });

                                    vm.respuesta = false;

                                }
                                vm.loading.close();

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },


            initChart() {


                var labels = this.list.map(function (x) {
                    return x.Nombre;
                });

                var dataI = this.list.map(function (x) {
                    return x.numIssues;
                });
                var dataD = this.list.map(function (x) {
                    return x.Dinero;
                });

                var randomColor = require('randomcolor');

                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

               // let backgroundColorsD = colors.map(rgba(179, 179, 0, 0.6));

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");

                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });

                let borderColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
                });

                let hoverBackgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
                });

                if (this.contador == 0) {

                    if (this.list.length > 0) {

                      this.objectChart = new Chart("chart", {

                        


                            type: 'horizontalBar',
                            data: {
                                labels: labels,
                                datasets: [{
                                    label: this.$t('Importe'),
                                    data: dataD,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1
                                },
                                {
                                    label: this.$t('Incidencia'),
                                    data: dataI,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1
                                }]
                            },
                            options: {
                                legend: { display: false,},
                                 scales: {
                                    xAxes: [{
                                        ticks: {
                                            beginAtZero: true,
                                            stepSize: 1
                                        }
                                    }]
                                },
                                responsive: true,
                                maintainAspectRatio: true,
                            }
                        });


                        this.contador++;
                    }
                } else {

                    this.objectChart.destroy();

                   this.objectChart = new Chart("chart", {

                             type: 'horizontalBar',
                            data: {
                                labels: labels,
                                datasets: [{
                                    label: this.$t('Dinero'),
                                    data: dataD,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1
                                },
                                {
                                    label: this.$t('Incidencia') ,
                                    data: dataI,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1
                                }]
                            },
                            options: {
                                legend: {display:false},
                                 scales: {
                                    xAxes: [{
                                        ticks: {
                                            beginAtZero: true,
                                             stepSize: 1
                                        }
                                    }]
                                },

                                responsive: true,
                                maintainAspectRatio: true,
                            }
                        });

                }
            }
        }
    }
</script>

<style scoped>

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Operarios/IncidenciasbyOperarios.vue